/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var ko = require("knockout");

var pliTextBoxObservable = require("../forms-knockoutcontrols");
require("../forms-knockoutcontrols-picklist");

if (require("targetenv").isBrowser) {
    require("./pliMultiselectBinding");
    ko.bindingHandlers.virtualScroll = require("./virtualScrollBindings");
}

module.exports = pliTextBoxObservable.behaviours.multiselect = require("./knockoutControlsMultiSelector");




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-knockoutcontrols-multiselect/index.js
// module id = 24
// module chunks = 49